module.exports = __webpack_public_path__ + "img/illusion-half-cn.e5628f6.svg";